<template>
  <div class="custom-input-group">
    <div
      v-for="(item, index) in podSerialNumberArr"
      :key="index"
      class="custom-input custom-input-char"
    >
      <input
        v-model="item.character"
        :disabled="item.disabled"
        :id="'character' + index"
        :maxlength="1"
        @input="inputFinish(index)"
        @focus="adjust(index)"
        @keydown="inputDirection($event, index)"
        :class="!item.character ? 'no-value-input' : ''"
      />
    </div>
    <div class="helper-text">
      <i class="el-icon-warning mr-5"></i
      ><i>{{ $t('text.please_enter_capital_letters_and_numbers') }}</i>
    </div>
  </div>
</template>

<script>
import { podSerialNumberDisplayPrefix } from '@/const'
export default {
  data() {
    return {
      activeInput: 1,
      podSerialNumberArr: [
        { character: podSerialNumberDisplayPrefix.charAt(0), disabled: true },
        { character: podSerialNumberDisplayPrefix.charAt(1), disabled: true },
        { character: podSerialNumberDisplayPrefix.charAt(2), disabled: true },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false },
        { character: '', disabled: false }
      ]
    }
  },
  props: {
    value: {
      type: String,
      require: true
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.podSerialNumberArr = [
          { character: podSerialNumberDisplayPrefix.charAt(0), disabled: true },
          { character: podSerialNumberDisplayPrefix.charAt(1), disabled: true },
          { character: podSerialNumberDisplayPrefix.charAt(2), disabled: true },
          { character: this.value.charAt(0), disabled: false },
          { character: this.value.charAt(1), disabled: false },
          { character: this.value.charAt(2), disabled: false },
          { character: this.value.charAt(3), disabled: false }
        ]
      } else {
        this.podSerialNumberArr = [
          { character: podSerialNumberDisplayPrefix.charAt(0), disabled: true },
          { character: podSerialNumberDisplayPrefix.charAt(1), disabled: true },
          { character: podSerialNumberDisplayPrefix.charAt(2), disabled: true },
          { character: '', disabled: false },
          { character: '', disabled: false },
          { character: '', disabled: false },
          { character: '', disabled: false }
        ]
      }
    }
  },
  methods: {
    adjust(index) {
      let dom = document.getElementById('character' + this.activeInput)
      if (index !== this.activeInput && dom) {
        dom.focus()
      }
    },
    inputDirection(event, index) {
      let val = this.podSerialNumberArr[index].character
      // Fallback key processing
      if (event.keyCode == 8 && val == '') {
        // Recalibrate
        this.activeInput = index - 1
        let dom = document.getElementById('character' + this.activeInput)
        if (dom) dom.focus()
      }
      if (event.keyCode != 8 && val != '') {
        this.activeInput = index + 1
        let dom = document.getElementById('character' + this.activeInput)
        if (dom) dom.focus()
      }
    },
    // The input boxes are interconnected
    inputFinish(index) {
      let specialRule = new RegExp(
        "[`~!@#$^&*()=_|+%{}':;',\\[\\].<>/?~@#￥……&*|{}]"
      )
      let str = this.podSerialNumberArr[index].character
      if (specialRule.test(str)) {
        this.podSerialNumberArr[index].character = ''
        return false
      }
      let val = this.podSerialNumberArr[index].character

      // Automatically convert to uppercase
      this.podSerialNumberArr.splice(index, 1, {
        character: val.toUpperCase(),
        disabled: false
      })

      // Automatically focus to the next input box
      this.activeInput = val ? index + 1 : index - 1
      let dom = document.getElementById('character' + this.activeInput)
      if (dom) dom.focus()
      this.$emit('podSerialNumberChange', this.podSerialNumberArr)
    }
  }
}
</script>
